<template>
  <div class="content">
    <div class="option">
      <span>头像：</span>
      <div class="option-con">
        <van-image
          round
          width="50px"
          height="50px"
          :src="avatar"
          @click="updataimg"
        />
        <div style="display: none" v-if="is_teacher == 0">
          <uploader ref="upload" :after-read="afterRead" />
          <!-- :after-read="afterRead" -->
        </div>
      </div>
    </div>
    <div class="option">
      <span>姓名：</span>
      <div class="option-con">
        <input type="text" placeholder="请输入姓名" v-model="name" />
      </div>
    </div>
    <template v-if="!id">
      <div class="option">
        <span>性别：</span>
        <div class="option-con">
          <div class="sex">
            <div @click="sex = 1">
              <div :class="sex == 1 ? 'radio-check' : 'radio'"></div>
              <span>男</span>
            </div>
            <div @click="sex = 0">
              <div :class="sex == 0 ? 'radio-check' : 'radio'"></div>
              <span>女</span>
            </div>
          </div>
        </div>
      </div>
      <div class="option" @click="selectDate">
        <span>出生年月日：</span>
        <div class="option-con">
          <!-- <span class="placeholder">请选择出生年月日</span> -->
          <span class="placeholder">{{ date }}</span>
        </div>
        <i class="iconfont icon-a-LeftArrow"></i>
      </div>

      <div class="option" @click="selectTime">
        <span>出生时辰：</span>
        <div class="option-con">
          <span class="placeholder">{{ time }}</span>
        </div>
        <i class="iconfont icon-a-LeftArrow"></i>
      </div>
    </template>

    <div class="buton" @click="submit">确认</div>

    <select-date
      v-model="show"
      :lunar="lunar"
      @confirm="dateConfirm"
      :date="date"
    />

    <select-time v-model="showTime" :date="time" @confirm="timeConfirm" />
  </div>
</template>

<script>
/**
@description:设置信息
@createTime:2021-09-21
@create:wq 
*/
// import { Popup, DatetimePicker } from "vant";

import selectDate from "../../../components/selectDate.vue";
import selectTime from "../../../components/selectTime.vue";

import { uploadimg } from "../../../utils/tool";
import { Toast, Uploader } from "vant";
// const imageCoversion = require("image-conversion");
export default {
  name: "",
  props: {},
  components: { selectDate, selectTime, Uploader },
  data() {
    return {
      avatar: "",
      name: "",
      show: false,
      showTime: false,
      sex: 1,
      date: "请选择出生年月日",
      time: "请选择出生时辰",
      lunar: 0,
      is_teacher:0,
      id:''
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.id = this.$route.query.id;
    if(this.id) {
      this.getData();
      return
    }
    const userinfo = JSON.parse(localStorage.getItem("user"));
    this.avatar = userinfo.avatar;
    
    this.lunar = userinfo.lunar;
    this.date = userinfo.year ? userinfo.year : "请选择出生年月日";
    this.time = userinfo.time ? userinfo.time : "请选择出生时辰";
    this.sex = userinfo.sex ? userinfo.sex : 1;
    this.is_teacher = userinfo.is_teacher;
    if(this.is_teacher){
      this.name = userinfo.name;
    }else{
      this.name = userinfo.username;
    }
  },
  methods: {
    getData(){
      this.api.userTeacherDetail({tid:this.id}).then(res => {
        let r = res.data;
        this.avatar = r.avatar;
        this.name = r.name;
      })
    },
    selectDate() {
      this.show = true;
    },
    dateConfirm(data) {
      this.lunar = data.lunar;
      this.date = data.date;
    },
    selectTime() {
      this.showTime = true;
    },
    timeConfirm(data) {
      this.time = data.date;
    },
    updataimg() {
      if(this.is_teacher == 0){
        this.$refs.upload.chooseFile();
      }
    },
    async afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      // 此时可以自行将文件上传至服务器
      await uploadimg(file).then((res) => {
        if (res) {
          this.avatar = res.complete_url;
        }
      });

      // const imgurl = await uploadimg(file);
      // console.log(imgurl, "imgurl");
      // if (imgurl) {
      //   this.avatar = imgurl.complete_url;
      // }
    },
    // afterRead(file) {
    //   file.status = "uploading";
    //   file.message = "上传中...";
    //   imageCoversion
    //     .compressAccurately(file.file, 200)
    //     .then((res) => {
    //       console.log(res, "---");
    //       file.file = res;
    //       // 此时可以自行将文件上传至服务器
    //       const imgurl = uploadimg(file, "user");
    //       console.log(imgurl, "imgurl");
    //       if (imgurl) {
    //         this.avatar = imgurl.complete_url;
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
    submit() {
      this.api
        .information({
          avatar: this.avatar,
          name: this.name,
          sex: this.sex,
          year: this.date,
          time: this.time,
          lunar: this.lunar,
          tid:this.id
        })
        .then(() => {
          if(!this.id){
            const userinfo = JSON.parse(localStorage.getItem("user"));
            userinfo.avatar = this.avatar;
            userinfo.username = this.name;
            userinfo.lunar = this.lunar;
            userinfo.year = this.date;
            userinfo.time = this.time;
            userinfo.isPerfect = 1;
            localStorage.setItem("user", JSON.stringify(userinfo));
          }
          Toast.success("成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 2000);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.2rem;
}
.option {
  display: flex;
  align-items: center;
  font-size: 0.3rem;
  color: #333333;
  border-bottom: 1px solid #dddddd;
  padding: 0.5rem 0;
  .option-con {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    input {
      width: 100%;
      border: none;
      outline: none;
    }
    > span {
      width: 100%;
    }
    .sex {
      display: flex;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
        margin-right: 100px;
        span {
          margin-left: 15px;
        }
      }
    }
    .placeholder {
      color: #999999;
    }
  }
  i {
    color: #cccccc;
    font-size: 12px;
  }
}
.buton {
  margin-top: 40px;
}
</style>
